import initializeSkipToContent from '../Entries/skipToContentEntry';
import initializeApplication from '../Entries/mainApplicationEntry';
import initializeApplicationHelper from '../Entries/helperEntry';
import initializeDestinationListHeader from "../Entries/destinationListHeaderEntry";
import initializeDestinationResultList from "../Entries/destinationResultListEntry";
import initializeUtilities from "../Entries/utilitiesEntry";
import initializeSearchMask from "Entries/searchMaskEntry";
import initializeProgressBar from "Entries/progressBarEntry";
import initializeFilterBarVertical from "Entries/filterBarVerticalEntry";
import initializeNavigation from "Entries/navigationEntry";
import initializeBurgerMenu from "Entries/burgerMenuEntry";
import initializeCouponElements from "Entries/couponEntry";
import initializePRGLink from "../Entries/prgLinkEntry";
import initializeLanguageSwitcherLinks from "../Entries/languageSwitcherEntry";
import initializeHotelDetailBookmarkHeart from "Entries/hotelDetailBookmarkHeartEntry";
var loginEntryPromise = import('../Entries/loginEntry');
window.sessionStorage.removeItem('hotel-list-sorting');
document.addEventListener('DOMContentLoaded', function () {
    document.body.className += ' loaded';
    initializeLanguageSwitcherLinks();
    initializeApplication();
    initializeBurgerMenu();
    initializeNavigation();
    initializeSearchMask();
    initializeProgressBar();
    initializeFilterBarVertical();
    initializeDestinationListHeader();
    initializeDestinationResultList();
    initializeUtilities();
    initializeCouponElements();
    initializePRGLink();
    initializeHotelDetailBookmarkHeart();
    initializeSkipToContent('worldwide', 'onetrust-banner-sdk');
    loginEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
});
window.addEventListener('load', function () {
    initializeApplicationHelper();
    initializeLanguageSwitcherLinks();
});
window.addEventListener('popstate', function (event) {
    location.reload();
});
